import React, { useCallback } from 'react';
import debouncePromise from 'debounce-promise';
import AsyncSelect from 'react-select-v3/async';

import { formatOptions, removeLettersFromId } from './utils';
import { searchOrderId } from 'modules/tasks/http';
import { orderSearchStyles } from './styled';

import Option from './Option';
import DropdownIndicator from './DropdownIndicator';

const t = {
  search: 'S/J0000000 ',
};

const OrderSearch = ({ value, setIdValue }) => {
  const handleLoadOptions = debouncePromise(async (input) => {
    const id = removeLettersFromId(input);
    const options = await searchOrderId(id);

    if (!options || !options.length) return [{ notFound: true }];
    return formatOptions(options, input);
  }, 600);

  const handleChange = useCallback(
    (change) => {
      const { journeyId, shipperOrderId } = change || {};

      if (!journeyId) return setIdValue(null);
      setIdValue({
        value: removeLettersFromId(journeyId),
        label: `${journeyId} (${shipperOrderId})`,
      });
    },
    [setIdValue]
  );

  return (
    <AsyncSelect
      isClearable
      disabled={false}
      invalid={false}
      filterOptions={false}
      placeholder={t.search}
      value={value}
      components={{ Option, DropdownIndicator }}
      onChange={handleChange}
      loadOptions={handleLoadOptions}
      styles={orderSearchStyles}
    />
  );
};

export default OrderSearch;
